import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../services/supabase';
import { findUserByUid, applyPendingReferralCode, ADMIN_EMAIL } from '../services/authService';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser]                       = useState(null);
  const [loading, setLoading]                 = useState(true);
  const [isLoggedIn, setIsLoggedIn]           = useState(false);
  const [profileComplete, setProfileComplete] = useState(false);
  const [isAdmin, setIsAdmin]                 = useState(false);

  const loadUser = async (session) => {
    if (!session?.user) {
      setUser(null);
      setIsLoggedIn(false);
      setProfileComplete(false);
      setIsAdmin(false);
      setLoading(false);
      return;
    }
    let profile = await findUserByUid(session.user.id);
    const email  = session.user.email;
    if (profile) {
      // Captura el ?ref= de la URL en cuanto exista un perfil (primer login),
      // sin esperar a que el usuario complete nombre/CPF/teléfono.
      if (!profile.referred_by) {
        const referredBy = await applyPendingReferralCode(session.user.id);
        if (referredBy) profile = { ...profile, referred_by: referredBy };
      }
      setUser(profile);
      setIsLoggedIn(true);
      setProfileComplete(!!profile.profile_complete);
      setIsAdmin(email === ADMIN_EMAIL);
    } else {
      setUser({ uid: session.user.id, email });
      setIsLoggedIn(true);
      setProfileComplete(false);
      setIsAdmin(email === ADMIN_EMAIL);
    }
    setLoading(false);
  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      loadUser(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => { loadUser(session); }
    );

    return () => subscription.unsubscribe();
  }, []);

  const fireUser = () => {
    setUser(null);
    setIsLoggedIn(false);
    setProfileComplete(false);
    setIsAdmin(false);
  };

  const refreshUser = async () => {
    if (!user?.uid) return;
    const profile = await findUserByUid(user.uid);
    if (profile) {
      setUser(profile);
      setProfileComplete(!!profile.profile_complete);
    }
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      isLoggedIn,
      profileComplete,
      isAdmin,
      fireUser,
      refreshUser,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
